import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { ILoadingConference } from 'interfaces/ILoadingConference'

import { useStyles } from './styles'


interface ModalInfoProps {
  open: boolean
  onClose: () => void
  loadingData: Partial<ILoadingConference>
  boxImageQuantity: number
}

const ModalInfo: React.FC<ModalInfoProps> = ({ open, onClose, loadingData, boxImageQuantity }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const paperStyle = isMobile ? { minWidth: '95vw', maxWidth: '98vw' } : { minWidth: 500 }

  const values = [
    { label: 'Reduzido na esteira', value: loadingData?.adjusted_boxes_number_conveyor },
    { label: 'Corrigido na esteira', value: loadingData?.corrected_boxes_number },
    { label: 'Lido na esteira', value: loadingData?.loading_boxes_number },
    { label: 'Reduzido antes da esteira', value: loadingData?.adjusted_boxes_number },
    { label: 'Na conferência', value: loadingData?.boxes_by_conferencer },
    { label: 'Na separação', value: loadingData?.conference_boxes_number },
  ]
  const consideredIdx = values.findIndex(v => v.value !== null && v.value !== undefined)
  const showValue = (value: number | null | undefined, isPhoto = false) =>
    value !== null && value !== undefined ? (
      <strong>
        {value} {value === 1 ? 'caixa' : 'caixas'}
      </strong>
    ) : (
      <strong>{isPhoto ? 'Nenhuma caixa com foto' : 'N/A'}</strong>
    )

  const showConsidered = (isConsidered: boolean) => {
    return isConsidered ? '✅' : '❌'
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: paperStyle }}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        Quantidade de Caixas
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <span role="img" aria-label="foto" style={{ fontSize: 22 }}>📷</span>
          {boxImageQuantity > 0 ? (
            <span style={{ marginLeft: 8, fontWeight: 600, fontSize: 16 }}>
              {boxImageQuantity} {boxImageQuantity === 1 ? 'caixa' : 'caixas'} com foto
            </span>
          ) : (
            <span style={{ marginLeft: 8, fontWeight: 600, fontSize: 16 }}>
              Nenhuma caixa com foto
            </span>
          )}
        </div>
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeadCell}>Etapa</TableCell>
                <TableCell className={classes.tableHeadCell}>Ficou com</TableCell>
                <TableCell className={classes.tableHeadCell}>Considerei?</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {values.map((item, idx) => (
                <TableRow key={item.label} className={classes.tableRow}>
                  <TableCell className={classes.tableCell}>{item.label}</TableCell>
                  <TableCell className={classes.tableCell}>{showValue(item.value)}</TableCell>
                  <TableCell className={classes.consideredCell}>{showConsidered(idx === consideredIdx)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ModalInfo
